import { all, call, takeLatest } from 'redux-saga/effects';
import { ActionTypes } from '../constants/index';
import { network } from './network';


export function* getPlan() {
  yield call(network, 'plan', 'info',
    ActionTypes.PLAN_GET_SUCCESS,
    ActionTypes.PLAN_GET_FAILURE,
  );
}

export function* selectPlan({ payload }) {
  yield call(network, 'plan', 'select',
    ActionTypes.PLAN_SELECT_SUCCESS,
    ActionTypes.PLAN_SELECT_FAILURE,
    { ...payload },
  );
}
export default function* root() {
  yield all([
    takeLatest(ActionTypes.PLAN_GET_REQUEST, getPlan),
    takeLatest(ActionTypes.PLAN_SELECT_REQUEST, selectPlan),
  ]);
}



// WEBPACK FOOTER //
// ./scripts/sagas/plan.js